import { IState } from '../../store';

export const selectBookingExistsModalOpened = (state: IState): boolean =>
  state.newbuildingBrokerOfferBooking.bookingExistsModalOpened;
